import { QueryParams } from 'redux/api/Widgets'
import { Condition, FilterType } from 'types/GlobalKpiOption'
import { CustomPeriodFilter, PeriodFilter } from 'types/GlobalWidget'
import { parsePeriodFilter } from 'utils/periodFilter'

function parseAttributeFilters(
  filterValues: Record<string, string[]>
): QueryParams | null {
  const dashboardFilterParams = Object.entries(filterValues).map(
    ([attributeId, values]) => ({
      attributeId,
      condition: Condition.EQ,
      value: values.map((v) => (v === 'Saknar värde' ? null : v)),
      type: FilterType.INPUT_VALUE
    })
  )

  if (dashboardFilterParams.length === 0) {
    return null
  }

  return { filter: dashboardFilterParams }
}

export function parseQueryParams(
  filterValues: Record<string, string[]>,
  periodFilter: PeriodFilter | CustomPeriodFilter | null
) {
  const filterQueryParams = parseAttributeFilters(filterValues)
  const periodQueryParams = parsePeriodFilter(periodFilter)

  if (periodQueryParams) {
    return {
      ...(filterQueryParams || {}),
      ...periodQueryParams
    }
  }

  return filterQueryParams
}
